import { useState } from 'react'

/**
 * The value just picked, shown until the saved one arrives: ``base`` is what the server said when it was
 * picked, so a refreshed value (or a failure) takes over again.
 */
export function usePicked<T extends string>(saved: T) {
  const [picked, setPicked] = useState<{ value: T; base: T } | null>(null)
  const shown = picked && picked.base === saved ? picked.value : saved
  return {
    shown,
    pick: (value: T) => setPicked({ value, base: saved }),
    clear: () => setPicked(null),
  }
}
